module.exports = __webpack_public_path__ + "staticfr/media/gif-dimen1.c13e454f.gif";